import { Drawer, Loading } from "@/components";
import { useGetNotificationDetail } from "@/hooks";
import { useAuthStore } from "@/store/authStore";
import { useNotificationStore } from "@/store/notificationStore";
import { ComponentProps } from "react";
import FormNotification from "./FormNotification";

const UpdateNotification = (
  props: Omit<ComponentProps<typeof Drawer>, "children">
) => {
  const { closeEditModal, editNotificationId } = useNotificationStore();

  // Get role to display form fields and build schema
  const { user } = useAuthStore();

  // Load initial data for editing when editNotificationId changes
  const { notification, isLoading } =
    useGetNotificationDetail(editNotificationId);

  if (isLoading) return <Loading />;

  const role = user?.role.name;

  return (
    <Drawer {...props}>
      {!!role && (
        <FormNotification
          onClose={closeEditModal}
          id={editNotificationId}
          initialData={notification}
          role={role}
        />
      )}
    </Drawer>
  );
};

export { UpdateNotification };
